import DisclosureGuidelineModal from '@Components/Bases/DisclosureGuidelineModal';
import InfoPopUpIcon from '@Components/Icons/InfoPopUpIcon';
import { useDisclosure } from '@hooks/useDisclosure';
import { Box, Button, Typography } from '@mui/material';

const DisclosureItem = (props: {
  title: string;
  risk: string;
  impact: string;
  riskManagement: string;
}) => {
  const { title, impact, risk, riskManagement } = props;
  return (
    <>
      <Typography fontStyle={'italic'}>{title}</Typography>
      <Typography sx={{ textIndent: 25 }}>
        -
        <Typography component={'span'} fontWeight={'bold'}>
          {' ความเสี่ยง: '}
        </Typography>
        {risk}
      </Typography>
      <Typography sx={{ textIndent: 25 }}>
        -
        <Typography component={'span'} fontWeight={'bold'}>
          {' ผลกระทบ: '}
        </Typography>
        {impact}
      </Typography>
      <Typography sx={{ textIndent: 25 }}>
        -
        <Typography component={'span'} fontWeight={'bold'}>
          {' มาตรการจัดการความเสี่ยง: '}
        </Typography>
        {riskManagement}
      </Typography>
    </>
  );
};

const DisclosureRiskManagement = () => {
  const [isOpen, { open, close }] = useDisclosure();

  return (
    <Box>
      <Button color="inherit" startIcon={<InfoPopUpIcon />} onClick={open}>
        แนวทางการเปิดเผย
      </Button>

      <DisclosureGuidelineModal
        open={isOpen}
        onClose={close}
        title="เป้าหมายและแผนงาน"
        description={
          <Box>
            <Typography fontWeight="bold">
              ข้อมูลความเสี่ยงที่มีนัยสำคัญของแผนการดำเนินงาน
            </Typography>
            <Box>
              <Typography sx={{ textIndent: 25 }}>
                -
                <Typography component={'span'} fontWeight={'bold'}>
                  {` ความเสี่ยงของแผนและผลกระทบ: `}
                </Typography>
                {`อธิบายสาเหตุและผลกระทบที่อาจทำให้เป้าหมายแผนไม่เป็นไปตามที่ตั้งไว้ โดยให้อธิบายถึงลักษณะความเสี่ยง เหตุการณ์ที่เป็นสาเหตุของความเสี่ยง ผลกระทบที่อาจเกิดขึ้น (ถ้าประเมินผลกระทบเป็นตัวเลขได้ให้ระบุด้วย) แนวโน้มหรือความเป็นไปได้ที่จะเกิดความเสี่ยงดังกล่าว`}
              </Typography>
              <Typography sx={{ textIndent: 25 }}>
                -
                <Typography component={'span'} fontWeight={'bold'}>
                  {` มาตรการจัดการความเสี่ยง: `}
                </Typography>
                {`ระบุมาตรการรองรับความเสี่ยงที่พบ และแนวทางการบรรเทาความเสี่ยงให้อยู่ในระดับที่สามารถยอมรับได้`}
              </Typography>
            </Box>
            <br />
            <Typography
              fontWeight="bold"
              fontStyle={'italic'}
              sx={{ textDecoration: 'underline' }}
            >
              ตัวอย่างแนวทางการเปิดเผยความเสี่ยงของแผนธุรกิจในรูปแบบต่างๆ
            </Typography>
            <Box>
              <Typography fontWeight="bold">1. แผนการขยายธุรกิจ</Typography>
              <DisclosureItem
                title={`1.1 ความเสี่ยงจากการขยายสายผลิตภัณฑ์`}
                risk={`การออกผลิตภัณฑ์ใหม่อาจไม่ประสบความสำเร็จตามเป้าหมายที่ตั้งไว้ เช่น การตอบสนองต่อความต้องการของตลาดไม่เป็นไปตามที่คาด การไม่สามารถควบคุมต้นทุนการผลิต และการจัดจำหน่ายที่ไม่ทั่วถึง`}
                impact={`อาจทำให้ต้นทุนเพิ่มขึ้น ขาดทุนจากการเปิดตัวผลิตภัณฑ์ใหม่ และสูญเสียความเชื่อมั่นจากผู้บริโภค`}
                riskManagement={`บริษัทมีการวิเคราะห์ตลาดและทดสอบผลิตภัณฑ์กับกลุ่มผู้บริโภคเป้าหมายล่วงหน้า เพื่อลดความเสี่ยงในการเปิดตัว และควรมีแผนการควบคุมต้นทุนการผลิตอย่างเข้มงวด พร้อมทั้งประเมินสถานการณ์และปรับกลยุทธ์การตลาดเมื่อจำเป็น`}
              />
              <br />
              <DisclosureItem
                title={`1.2 ความเสี่ยงจากการขยายตัวทางภูมิศาสตร์`}
                risk={`การเข้าสู่ตลาดต่างประเทศอาจเจอกับความท้าทาย เช่น กฎหมายและข้อบังคับที่แตกต่างกัน ความเสี่ยงด้านอัตราแลกเปลี่ยน การจัดการขนส่ง การปรับตัวให้เข้ากับวัฒนธรรมและพฤติกรรมของผู้บริโภคในพื้นที่ การพึ่งพาความสามารถของตัวแทนจำหน่าย หรือตัวกลางในการพาบริษัทเข้าสู่ตลาดนั้น ๆ`}
                impact={`อาจทำให้เสียค่าใช้จ่ายในการปรับตัวสูง ไม่สามารถขยายตลาดได้ตามเป้าหมาย และสูญเสียการลงทุน`}
                riskManagement={`บริษัทศึกษาตลาดอย่างละเอียด จัดทำแผนความเสี่ยงด้านกฎหมายและการเงิน และเลือกพันธมิตรท้องถิ่นที่มีประสบการณ์ในตลาดนั้น ๆ เพื่อช่วยลดความเสี่ยง`}
              />
              <br />
              <DisclosureItem
                title={`1.3 ความเสี่ยงจากการขยายช่องทางการจัดจำหน่าย`}
                risk={`อาจพบกับความท้าทายในการหาพันธมิตรจัดจำหน่ายใหม่และควบคุมคุณภาพในการให้บริการแก่ลูกค้า`}
                impact={`อาจทำให้บริษัทสูญเสียฐานลูกค้าเดิม และเสียค่าใช้จ่ายในการจัดการช่องทางการจัดจำหน่ายใหม่`}
                riskManagement={`บริษัทตรวจสอบคุณภาพของพันธมิตรจัดจำหน่ายที่เลือกใช้ และมีแผนการควบคุมการให้บริการเพื่อรักษาภาพลักษณ์ของแบรนด์`}
              />
            </Box>
            <br />
            <Box>
              <Typography fontWeight="bold">2. การจัดการต้นทุน</Typography>
              <DisclosureItem
                title={`2.1 ความเสี่ยงจากการเพิ่มประสิทธิภาพพนักงาน`}
                risk={`การฝึกอบรมพนักงานอาจไม่ส่งผลตามที่คาดหวัง และอาจพบกับการต่อต้านการเปลี่ยนแปลงจากพนักงาน`}
                impact={`การเพิ่มประสิทธิภาพในการทำงานอาจล่าช้ากว่าที่ตั้งเป้าไว้ และทำให้ต้นทุนการฝึกอบรมเพิ่มขึ้น`}
                riskManagement={`บริษัทรสื่อสารกับพนักงานเกี่ยวกับความสำคัญของการเปลี่ยนแปลงนี้อย่างชัดเจน จัดฝึกอบรมที่เหมาะสมและปรับปรุงการทำงานให้สอดคล้องกับความต้องการของพนักงาน`}
              />
              <br />
              <DisclosureItem
                title={`2.2 ความเสี่ยงจากการปรับปรุงกระบวนการผลิต`}
                risk={`การเปลี่ยนแปลงในกระบวนการผลิตอาจทำให้เกิดการหยุดชะงักหรือเกิดปัญหาด้านคุณภาพผลิตภัณฑ์ชั่วคราว`}
                impact={`อาจเกิดความสูญเสียในการผลิต ทำให้เสียลูกค้าและรายได้`}
                riskManagement={`บริษัทมีแผนการทดลองกระบวนการใหม่ก่อนนำไปใช้จริง และเฝ้าระวังคุณภาพอย่างใกล้ชิดในช่วงแรกของการปรับปรุง`}
              />
              <br />
              <DisclosureItem
                title={`2.3 ความเสี่ยงจากการลงทุนในเทคโนโลยีระบบอัตโนมัติ`}
                risk={`ระบบอัตโนมัติอาจมีค่าใช้จ่ายสูงในการติดตั้งและบำรุงรักษา และอาจมีปัญหาด้านการทำงานในช่วงแรกของการใช้งาน`}
                impact={`ต้นทุนในการดำเนินงานเพิ่มขึ้นและต้องการเวลานานกว่าในการคืนทุน`}
                riskManagement={`บริษัทเริ่มต้นโครงการนำร่อง (pilot project) เพื่อทดสอบระบบก่อนการลงทุนเต็มรูปแบบ และจัดทำแผนการบำรุงรักษาระบบอย่างต่อเนื่อง`}
              />
            </Box>
            <br />
            <Box>
              <Typography fontWeight="bold">3. แผนการลงทุน</Typography>
              <DisclosureItem
                title={`3.1 ความเสี่ยงจากการเพิ่มงบประมาณด้านการวิจัยและพัฒนา (R&D)`}
                risk={`ผลิตภัณฑ์ที่พัฒนาขึ้นอาจไม่ตอบสนองต่อความต้องการของตลาดหรืออาจถูกคู่แข่งลอกเลียนแบบได้ง่าย`}
                impact={`อาจทำให้บริษัทสูญเสียเวลาและทรัพยากร และไม่สามารถสร้างรายได้เพิ่มตามเป้าหมายได้`}
                riskManagement={`บริษัทวิจัยตลาดอย่างละเอียดเพื่อให้แน่ใจว่าผลิตภัณฑ์ใหม่มีความต้องการ และใช้มาตรการทางกฎหมายเพื่อปกป้องทรัพย์สินทางปัญญา`}
              />
              <br />
              <DisclosureItem
                title={`3.2 ความเสี่ยงจากการควบรวมกิจการหรือเข้าซื้อกิจการ (M&A)`}
                risk={`การควบรวมกิจการอาจประสบปัญหาทางด้านวัฒนธรรมองค์กร การผสานระบบที่แตกต่างกัน หรือความเสี่ยงด้านการเงิน`}
                impact={`อาจทำให้ประสิทธิภาพการทำงานลดลงและเกิดการสูญเสียเงินลงทุนหากการควบรวมไม่สำเร็จ`}
                riskManagement={`บริษัทจัดทำแผนบูรณาการอย่างละเอียด ศึกษาองค์กรที่เข้าซื้ออย่างรอบคอบ และมีทีมผู้เชี่ยวชาญด้านการควบรวมกิจการดูแลการดำเนินงานอย่างใกล้ชิด`}
              />
            </Box>
            <br />
            <Box>
              <Typography fontWeight="bold">4. แผนการจัดการหนี้</Typography>
              <DisclosureItem
                title={`4.1 ความเสี่ยงจากการชำระหนี้ตามแผน`}
                risk={`หากเกิดปัญหาทางการเงินหรือรายได้ลดลง อาจไม่สามารถชำระหนี้ตามแผนที่วางไว้ได้`}
                impact={`การชำระหนี้ล่าช้าอาจทำให้บริษัทเสียเครดิตทางการเงินและต้องเสียค่าใช้จ่ายเพิ่มเติมจากดอกเบี้ยและค่าปรับ`}
                riskManagement={`บริษัทจัดทำแผนบริหารกระแสเงินสดที่เหมาะสมและสำรองเงินไว้ในกรณีฉุกเฉิน นอกจากนี้ ได้เจรจาเรื่องการขยายเวลาชำระหนี้กับสถาบันการเงิน`}
              />
              <br />
              <DisclosureItem
                title={`4.2 ความเสี่ยงจากการปรับโครงสร้างทุน`}
                risk={`การออกตราสารหนี้ที่อาจไม่ประสบความสำเร็จในการเสนอขายและทำให้บริษัทไม่สามารถปรับโครงสร้างทุนได้`}
                impact={`หากแผนการปรับโครงสร้างทุนไม่ประสบความสำเร็จอาจทำให้ความเชื่อมั่นในบริษัทลดลงและส่งผลให้เกิดความกังวลเกี่ยวกับความสามารถในการระดมทุนของบริษัทในอนาคต`}
                riskManagement={`บริษัทสื่อสารกับผู้ถือหุ้นถึงประโยชน์ที่ได้รับจากการปรับโครงสร้างทุนนี้อย่างชัดเจน และจัดทำแผนการเพิ่มทุนในลักษณะที่สร้างความมั่นใจให้แก่ผู้ถือหุ้น`}
              />
            </Box>
          </Box>
        }
      />
    </Box>
  );
};

export default DisclosureRiskManagement;
